import { ITranslationOptions } from '../../../../models/translationOptions'
import {
  TRANSLATION_KEYS,
  TRANSLATION_KEYS_DISTRIBUTOR,
  TRANSLATION_KEYS_RETAIL,
} from '../translations'

export const getBranchesFieldLabelTranslation = ({
  isRetail,
  isDistributor,
}: ITranslationOptions) => {
  if (isRetail) {
    return TRANSLATION_KEYS_RETAIL.fieldLabel
  }

  if (isDistributor) {
    return TRANSLATION_KEYS_DISTRIBUTOR.fieldLabel
  }

  return TRANSLATION_KEYS.fieldLabel
}
